import { Collapse, Divider } from "antd";
import {
	SubmitButtonOverlay,
	ActionContainer,
	ActionItemsContainer,
} from "../../components/styled/common";
import { CDNFileItems } from "./constants";
import CollapseExpandIcon from "../../components/CollapseExpandIcon";
import MainButtonComponent from "../../components/MainButtonComponent";
import { useCDNFileContext } from "../../context/CDNFileContext/CDNFileContext";

const AddCDNFile = () => {
	const { addCDNFile, operationStatus } = useCDNFileContext();

	return (
		<ActionContainer>
			<ActionItemsContainer>
				<h3>Yeni CDN Dosyası Ekleme</h3>
				<Divider />
				<Collapse
					items={CDNFileItems}
					expandIconPosition="end"
					bordered={false}
					ghost
					expandIcon={CollapseExpandIcon}
					defaultActiveKey={["1", "2"]}
				/>
				<SubmitButtonOverlay>
					<MainButtonComponent onClick={addCDNFile} loading={operationStatus.type === "loading" && operationStatus.operation === "add"}>
						Dosyayı Ekle
					</MainButtonComponent>
				</SubmitButtonOverlay>
			</ActionItemsContainer>
		</ActionContainer>
	);
};

export default AddCDNFile;
